export const REGIONS = [
  { label: 'IAD (us-east-1)', value: 'us-east-1', description: 'NA' },
  { label: 'PDX (us-west-2)', value: 'us-west-2', description: 'FE' },
  { label: 'ZAZ (eu-south-2)', value: 'eu-south-2', description: 'EU' },
  { label: 'DUB (eu-west-1)', value: 'eu-west-1', description: 'EU' },
];

// Region -> API subdomain alias. Authoritative map; also drives the local dev proxy.
const REGION_ALIAS: Record<string, string> = {
  'us-east-1': 'na',
  'us-west-2': 'fe',
  'eu-south-2': 'zaz',
  'eu-west-1': 'eu',
};

// Stage -> API hostname prefix. Prod serves at the apex (no prefix).
const STAGE_PREFIX: Record<string, string> = {
  Alpha: 'alpha',
  Beta: 'beta',
  Gamma: 'gamma',
  Prod: '',
};

const BEACON_DOMAIN = 'beacon.fintech.amazon.dev';

export const DEFAULT_STAGE = 'Alpha';
export const DEFAULT_REGION = 'us-east-1';

/**
 * Derives the stage from the current URL hostname.
 */
export const getStageFromUrl = (): string => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'Alpha';
  if (hostname.includes('alpha')) return 'Alpha';
  if (hostname.includes('beta')) return 'Beta';
  if (hostname.includes('gamma')) return 'Gamma';
  if (hostname.includes('prod')) return 'Prod';
  return DEFAULT_STAGE;
};

/** Reads the selected region from the URL (?region=), validated against REGIONS; falls back to DEFAULT_REGION. */
export const getRegionFromUrl = (): string => {
  if (typeof window === 'undefined') return DEFAULT_REGION;
  const region = new URLSearchParams(window.location.search).get('region');
  return region && REGIONS.some(r => r.value === region) ? region : DEFAULT_REGION;
};

/**
 * Builds the regional API base URL deterministically from (stage, region):
 *   non-prod: https://<stage>.<alias>.beacon.fintech.amazon.dev
 *   prod:     https://<alias>.beacon.fintech.amazon.dev
 * On localhost it returns that region's dev-proxy prefix (see configuration/webpack.config.js).
 * Throws on an unknown stage or region — no silent fallback to a default region.
 */
export const getApiBase = (stage: string, region: string): string => {
  const alias = REGION_ALIAS[region];
  if (!alias) throw new Error(`getApiBase: unknown region "${region}"`);
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `/api-${alias}`;
  }
  const prefix = STAGE_PREFIX[stage];
  if (prefix === undefined) throw new Error(`getApiBase: unknown stage "${stage}"`);
  return `https://${prefix ? `${prefix}.` : ''}${alias}.${BEACON_DOMAIN}`;
};
